const createExportDateHandler = (requestData) => (values) => {
    requestData.startDate = values[0] ?? null;
    requestData.endDate = values[1] ?? null;
};

export default createExportDateHandler;